var _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedConversionTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "conversion_failed",
    "data-name": "conversion failed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 41,
    viewBox: "0 0 79 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "needs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    fill: "rgba(162,17,16,0.05)",
    stroke: "#a21110",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 36,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 78,
    height: 36,
    rx: 4,
    fill: "none"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "FailedConversion",
    "data-name": "FailedConversion",
    transform: "translate(8 15)",
    fill: "#a21110",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Conversion"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "FailedConversion",
    "data-name": "FailedConversion",
    transform: "translate(22 30)",
    fill: "#a21110",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Failed"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedConversionTag);
export default __webpack_public_path__ + "static/media/failed_conversion_tag.a15915bf7f378071f3079fa9864d4b68.svg";
export { ForwardRef as ReactComponent };